export const PLACEHOLDER_DATA = {
  "sop-review": (university, program) => ({
    _id: "sop-review",
    title: `Looking for SOP Review by ${program} mentor`,
    requestee: {
      firstName: "Taru",
      lastName: "Bhargava",
      avatar: {
        thumbNail: "https://xsgames.co/randomusers/assets/avatars/female/7.jpg",
      },
      credential: `Bachelor's in Computer Science, Bengaluru`,
      caption: `Interested in ${program}`,
    },
    request: [
      `Need someone to review my SOP & LOR for ${program}`,
      `Would be great if the reviewer also provides guidance to improve the SOP and LOR`,
    ],
    price: 50,
  }),
  "lor-review": (university, program) => ({
    _id: "lor-review",
    title: `Looking for LOR Review by ${program} mentor at ${university}`,
    requestee: {
      firstName: "Yogi",
      lastName: "Bhatt",
      avatar: {
        thumbNail: "https://xsgames.co/randomusers/assets/avatars/male/7.jpg",
      },
      credential: "Bachelor's in Computer Science",
      caption: "Interested in Masters in Computer Science",
    },
    request: [
      `I want to understand the best method to write LOR for a ${program} from ${university}?`,
      `How to effectively communicate my dreams and aspirations within the word limit?`,
      `I would like to receive Feedback and review of the LOR that I have drafted`,
    ],
    price: 5,
  }),
  "life-at-campus": (university) => ({
    _id: "life-at-campus",
    title: `Looking for an Insider's Guide to ${university} Campus Life`,
    requestee: {
      firstName: "Shubham",
      lastName: "M.",
      avatar: {
        thumbNail: "https://xsgames.co/randomusers/assets/avatars/male/8.jpg",
      },
      credential: "Bachelor's from India",
      caption: "Interested in MBA",
    },
    request: [
      `How is the campus life at ${university}?`,
      `How is the placement support at ${university}?`,
      `How can I find the best housing facilities on campus?`,
      `What are the tips to getting involved in extracurricular activities, such as clubs, societies, and sports teams?`,
      `How to access campus resources and support services?`,
    ],
    price: 5,
  }),
  "cv-review": (university, program) => ({
    _id: "cv-review",
    title: `Looking for guidance to write a CV after my ${program} from ${university}`,
    requestee: {
      firstName: "AZ",
      lastName: "Hanza",
      avatar: {
        thumbNail:
          "https://xsgames.co/randomusers/assets/avatars/female/10.jpg",
      },
      credential: "Bachelor's in Computer Science",
      caption: "Interested in Jobs after Masters in Computer Science",
    },
    request: [
      `What is the best method to write a CV for a job after my masters programme`,
      `How can I grab the attention of the hiring manager with writing and design style of the CV`,
      `How to effectively communicate my aspirations and goals in an impressive manner`,
      `I would like to receive Feedback and review on the CV I have drafted`,
    ],
    price: 5,
  }),
  "university-shortlisting": (program) => ({
    _id: "university-shortlisting",
    title: `Looking for help to shortlist universities for ${program}`,
    requestee: {
      firstName: "Zac",
      lastName: "Effron",
      avatar: {
        thumbNail: "https://xsgames.co/randomusers/assets/avatars/male/10.jpg",
      },
      credential: "Bachelor's in Computer Science",
      caption: "Interested in Masters in Computer Science",
    },
    request: [
      `What is the process I should follow while shortlisting universities`,
      `What are the major facilities and teaching method I have to look for while shortlisting universities from UK for the ${program}`,
      `How to find and shortlist back-up universities that facilitates my dream course`,
      `What should I include in my checklist before, during and after the application is sent to the university`,
    ],
    price: 5,
  }),
};

export const HOW_ORDER_WORKS = [
  "Aspirant outlines the mentorship s/he needs",
  "Aspirant pledges an amount as a token of thanks for mentor’s time",
  "Mentor reviews & accepts the request",
  "A chat channel is established between both sides",
  "Mentor mentors the Aspirant",
  "Mentor closes the order once the mentorship is delivered",
  "Pledged amount gets credited to the Mentor’s settlement account",
];

export const UNIVERSITY_LIST = {
  "university-of-oxford": "University of Oxford",
  "university-of-bedfordshire": "University of Bedfordshire",
  "imperial-college-london": "Imperial College London",
  "university-of-hertfordshire": "University of Hertfordshire",
  "university-of-edinburgh": "University of Edinburgh",
  "university-of-manchester": "University of Manchester",
  "university-of-bristol": "University of Bristol",
  "university-of-glasgow": "University of Glasgow",
  "university-of-southampton": "University of Southampton",
  "university-of-leeds": "University of Leeds",
  "university-of-sheffield": "University of Sheffield",
  "university-of-nottingham": "University of Nottingham",
  "the-university-of-greenwich": "The University of Greenwich",
  "university-of-aberdeen": "University of Aberdeen",
  "university-of-st.-andrews": "University of St. Andrews",
  "griffith-university": "Griffith University",
  any: "any",
};

export const PROGRAM_LIST = {
  mba: "Master in Business Administration",
  "masters-in-computer-science": "Masters in Computer Science",
  "masters-in-ai-ml": "Masters in AI ML",
  "masters-in-data-science": "Masters in Data Science",
  "masters-in-robotics": "Masters in Robotics",
  "masters-in-statistics-and-ai": "Masters in Statistics and AI",
};

export const MENTORS_DASH = [
  {
    name: "Aarohi Garg",
    link: "https://youtu.be/5YX9cByx2wI",
    cred: "Erasmus Mundus Scholar from Turuk, Finland",
    title: "Review of your Motivation Letter for Erasmus Mundus Scholarship",
    review: {
      remark: "Thanks for sharing your journey, the talk was inspiring...",
      reviewer: "From Namitha, Study in Finland Aspirant",
    },
  },
  {
    name: "Yasir Mohammed",
    cred: "Software Engineer at Zoom, Germany",
    link: "https://youtu.be/PNqPoZqevMA",
    review: {
      remark: "Wonderful session. Got so much info...",
      reviewer:
        "From Rakesh, Study in Germany, MSc in Artificial Intelligence aspirant",
    },
    title:
      "My journey from LPU India to being a Software Engineer at Zoom BW, Germany",
  },
];

export const ORDERS_FAQ = [
  {
    question: "Are there any fees for listing my mentoring services on Nbyula?",
    answer:
      "No fees are associated with listing your mentoring services on Nbyula.",
  },
  {
    question:
      "When will the fees for my listed service/order be credited to my account?",
    answer:
      "After the completion of the service, Nbyula will verify and credit the fees to your account within 2-3 business days for Indian Card holders and 5-7 business days for International Card holders.",
  },
  {
    question:
      "What commission percentage does Nbyula charge for services/orders listed by service providers?",
    answer:
      "Nbyula charges 3.5% as platform fee for services/orders listed, with the remaining percentage going to the service provider.",
  },
  {
    question:
      "What method will be used for the delivery of the service if I accept an order request?",
    answer:
      "The delivery of the service can be conducted through Nbyula Meet (video call) or the chat section, depending on your preference.",
  },
  {
    question: "Can I remove my mentorship from Nbyula?",
    answer:
      "Yes, mentors can contact Nbyula's support team to have their services removed from the platform at any time.",
  },
  {
    question:
      "What should I do if I encounter a problem with a client or an order on Nbyula?",
    answer:
      "If any issues arise with a client or an order, please reach out to Nbyula's customer support team for assistance. We will help you resolve the issue and safeguard your rights as a Student mentor.",
  },
];
